import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Category } from '../../interfaces/category.model';
import { Asset } from '../../interfaces/asset.model';
import { FileProvider } from '../../providers/file/file';
import { StorageProvider } from '../../providers/storage/storage';
import { CategoriesProvider } from '../../providers/categories/categories';
import { HelperProvider } from '../../providers/helper/helper';
import { FilterProvider } from '../../providers/filter/filter';
import { Language } from '../../interfaces/language.model';
import { LanguageProvider } from '../../providers/language/language';
import { IndicationProvider } from '../../providers/indication/indication';
import { AudienceProvider } from '../../providers/audience/audience';


@IonicPage()
@Component({
  selector: 'page-subcategories',
  templateUrl: 'subcategories.html',
})
export class SubcategoriesPage {

  selectedCategorie: Category;
  categories: Category[];
  assets: Asset[];
  filterType: string;
  selectedIndicationId: number;
  selectedLanguage: Language;
  languages: Language[];
  displayAsList: boolean;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    public storageService: StorageProvider, 
    public fileService: FileProvider, 
    public categoriesService: CategoriesProvider, 
    public filterService: FilterProvider, 
    public helperService: HelperProvider,
    public languageService: LanguageProvider,
    public indicationService: IndicationProvider,
    public audienceService: AudienceProvider) {
    this.selectedCategorie = navParams.get('category');
    this.filterType = "asc";
  }

  ionViewDidLoad() {
    this.categories = this.filterBySubCategories();
    this.assets = this.filterAssets();
    this.languages = this.languageService.getAllLanguages();
    this.indicationService.currentIndication.subscribe(selectedIndicationId => {
      if(this.selectedCategorie.IsIndicationCategory){
        this.selectedIndicationId = selectedIndicationId
      } else {
        this.selectedIndicationId = null;
      }
    });
  }

  ionViewWillEnter(){
    this.setSelectedLanguage();
    this.getDisplayListView();
  }

  /* LIST VIEW */

  getDisplayListView(){
    this.storageService.getDataStorage("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storageService.setDataStorage("displayAsList", this.displayAsList);
  }

  setSelectedLanguage(){
    this.languageService.getSelectedLang()
    .then(selectedLanguage => {
      if(selectedLanguage == null){
        this.selectedLanguage = this.languages[0];
        this.languageService.setSelectedLang(this.selectedLanguage.LanguageCode);
      } else {
        this.selectedLanguage = this.languages.find(lang => lang.LanguageCode == selectedLanguage);
      }
    }).catch(error => this.selectedLanguage = this.languages[0]);
  }

  filterBySubCategories(){
    return this.categoriesService.filterByCategories(this.selectedCategorie.CategoryId);
  }

  filterAssets() {
    return this.filterService.filterAssetsByCategory(this.selectedCategorie.CategoryId);
  }

  updateAssets() {
    console.log("SubcategoriesPage::updateAssets()");
    this.assets = this.filterAssets();
  }

  updateFilter(value){
    console.log("[SubcategoriesPage] New order: " + value);
    this.filterType = value;
  }
}



// WEBPACK FOOTER //
// ./src/pages/subcategories/subcategories.ts